import { render } from "./AppSubHeaderView.vue?vue&type=template&id=5990c11a&scoped=true"
import script from "./AppSubHeaderView.vue?vue&type=script&lang=js"
export * from "./AppSubHeaderView.vue?vue&type=script&lang=js"

import "./AppSubHeaderView.vue?vue&type=style&index=0&id=5990c11a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5990c11a"]])

export default __exports__